var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cancel-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-Company->-cancel-subscription",
    transform: "translate(-296.000000, -200.000000)",
    fill: "#F26558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,200 C300.488667,200 296,204.488667 296,210 C296,215.511333 300.488667,220 306,220 C311.511333,220 316,215.511333 316,210 C316,204.489556 311.511333,200 306,200 Z M309.333333,212.644889 C309.511284,212.82284 309.511284,213.1336 309.333333,213.311556 C309.155382,213.489511 308.844622,213.489507 308.666667,213.311556 L306,210.644889 L303.333333,213.311556 C303.155382,213.489507 302.844622,213.489507 302.666667,213.311556 C302.488711,213.133604 302.488716,212.822844 302.666667,212.644889 L305.333333,209.978222 L302.666667,207.311556 C302.488716,207.133604 302.488716,206.822844 302.666667,206.644889 C302.844618,206.466933 303.155378,206.466938 303.333333,206.644889 L306,209.311556 L308.666667,206.644889 C308.844618,206.466938 309.155378,206.466938 309.333333,206.644889 C309.511289,206.82284 309.511284,207.1336 309.333333,207.311556 L306.666667,209.978222 L309.333333,212.644889 Z",
    id: "cancel-icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSubscription);
export default __webpack_public_path__ + "static/media/cancel-subscription.0d9e307cc1c2fe8d30b06965d83ba633.svg";
export { ForwardRef as ReactComponent };